import Vue from 'vue';
import Vuex from 'vuex';
import VueCompositionAPI from '@vue/composition-api';
import vClickOutside from 'v-click-outside'
import store from 'Assets/js/Vuex/Store/store';
import jsUtils from '@pernod-ricard-global-cms/jsutils';
import mainMenu from 'Templates/global/MainMenu/index.vue';
import globalTheme from 'Assets/js/components/globalTheme';
import VueFlags from '@growthbunker/vueflags';

Vue.use(Vuex);
Vue.use(VueFlags, {
  iconPath: `${window.location.origin}/wp-content/themes/global-theme/assets/images/flags/`
});
Vue.use(VueCompositionAPI);
Vue.use(vClickOutside);

export default function mainMenuTwo() {
  const options = document.getElementById('NewMenu');
  try {
    if (!options) {
      return;
    }

    if (options.dataset.initialized === 'true') {
      return;
    }

    options.dataset.initialized = 'true';
    const bootStart = window.performance?.now?.() || 0;
    const mountElement = options.querySelector('[data-assetkey="main-menu"]');
    if (!mountElement) {
      return;
    }

    const app = new Vue({
      name: 'Main Menu',
      data: { ...mountElement.dataset, options },
      render: (h) => h(mainMenu),
      store,
      created() {
        if (!this.$store) {
          return;
        }

        const menus = this.$store.state.menus || {};
        const brandsmenu = this.$store.state.brandsmenu;

        if (!menus.brandsmenu && !brandsmenu) {
          this.$store.dispatch('brandsmenu');
        }

        const brandmenus = this.$store.state.brandmenus;

        if (!menus.brandmenus && !brandmenus) {
          this.$store.dispatch('brandmenus');
        }

        if (!this.$store.state.usp) {
          this.$store.dispatch('usp');
        }
      }
    }).$mount(mountElement);

    const removePlaceholder = () => {
      const placeholder = options.querySelector('[data-menu-placeholder="true"]');
      if (placeholder) {
        placeholder.remove();
      }
    };

    // $mount replaces mountElement in the DOM with the root component element,
    // so the readiness check has to run against app.$el. Checking mountElement
    // searches a detached node and never succeeds. See OSS-2663.
    const menuIsReady = () => {
      const root = app.$el;
      if (!root || typeof root.querySelector !== 'function') {
        return false;
      }
      const wrapper = root.matches('.main-menu-wrapper, .main-menu-wrapper__v2')
        ? root
        : root.querySelector('.main-menu-wrapper, .main-menu-wrapper__v2');
      return !!(wrapper && wrapper.children && wrapper.children.length > 0);
    };

    if (menuIsReady()) {
      removePlaceholder();
    } else {
      const observer = new MutationObserver(() => {
        if (!menuIsReady()) {
          return;
        }
        observer.disconnect();
        removePlaceholder();
      });
      observer.observe(options, { childList: true, subtree: true });

      window.addEventListener('oss:main-menu-ready', () => {
        observer.disconnect();
        removePlaceholder();
      }, { once: true });

      // Last resort: a skeleton left on screen is worse than one removed early.
      window.setTimeout(() => {
        observer.disconnect();
        removePlaceholder();
      }, 3000);
    }

    const mountedAt = window.performance?.now?.() || 0;
    try {
      window.__MDC_CLIENT_BOOT = window.__MDC_CLIENT_BOOT || {};
      window.__MDC_CLIENT_BOOT.mainMenu = {
        bootStartMs: Number(bootStart.toFixed(1)),
        mountedMs: Number(mountedAt.toFixed(1)),
        mountDurationMs: Number((mountedAt - bootStart).toFixed(1))
      };
      console.log('MDC main menu boot', window.__MDC_CLIENT_BOOT.mainMenu);
    } catch (_) {}

    // Backfill menu CSS without blocking initial mount.
    Promise.all([
      import('Assets/scss/components/global/main-menu.scss'),
      import('Assets/scss/components/global/_brand-logo-images.scss')
    ]).then(() => {
      try {
        const cssLoadedAt = window.performance?.now?.() || 0;
        window.__MDC_CLIENT_BOOT = window.__MDC_CLIENT_BOOT || {};
        window.__MDC_CLIENT_BOOT.mainMenu = {
          ...(window.__MDC_CLIENT_BOOT.mainMenu || {}),
          cssImportsLoadedMs: Number(cssLoadedAt.toFixed(1))
        };
        console.log('MDC main menu css imports', window.__MDC_CLIENT_BOOT.mainMenu);
      } catch (_) {}
    }).catch(() => {});
    jsUtils.loadCss(options.dataset.assetkey, options).then(() => {
      try {
        const blockCssLoadedAt = window.performance?.now?.() || 0;
        window.__MDC_CLIENT_BOOT = window.__MDC_CLIENT_BOOT || {};
        window.__MDC_CLIENT_BOOT.mainMenu = {
          ...(window.__MDC_CLIENT_BOOT.mainMenu || {}),
          blockCssLoadedMs: Number(blockCssLoadedAt.toFixed(1))
        };
        console.log('MDC main menu block css', window.__MDC_CLIENT_BOOT.mainMenu);
      } catch (_) {}
    }).catch(() => {});

    if (window.grecaptcha) {
      // eslint-disable-next-line func-names
      window.ReCaptchaCallbackV3 = function () {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(window.global_theme_object.recapcha_site_key)
            .then((token) => {
              const recaptchaResponse = document.getElementById(
                'g-recaptcha-response'
              );
              if (recaptchaResponse) {
                recaptchaResponse.value = token;
                console.log('reCAPTCHA is set up.');
              }
            });
        });
      };
      const reCAPTCHA = document.createElement('script');
      reCAPTCHA.src = `https://www.google.com/recaptcha/api.js?onload=ReCaptchaCallbackV3&render=${window.global_theme_object.recapcha_site_key}`;
      document.head.appendChild(reCAPTCHA);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
